import { selectFilterId } from '../selectors';
import * as types from '../types';

function setDirectOnlyActive(isActive, filterId) {
    return (dispatch, getState) => {
        const id = filterId || selectFilterId(getState());
        return id && dispatch(set(id, isActive));
    };
}

function set(filterId, isActive) {
    return {
        meta: filterId,
        payload: isActive,
        type: types.SET_DIRECT_ONLY_ACTIVE,
    };
}

function resetDirectOnly(filterId) {
    return (dispatch, getState) => {
        const id = filterId || selectFilterId(getState());
        return id && dispatch(reset(id));
    };
}

function reset(filterId) {
    return {
        meta: filterId,
        type: types.RESET_DIRECT_ONLY,
    };
}

export {
    resetDirectOnly,
    setDirectOnlyActive,
};
